module.exports = require("@swa-ui/shopping/src/FareOptionDetails/FareOptionDetails.module.scss");